import classes from './CreateTNEPage.module.scss';
import CreateTimeandExpense from '../../../Components/pages/CreateTimeandExpense/CreateTimeandExpense';

export default function CreateTNEPage({ type }) {
  return (
    <section className={`${classes.pageContainer}`}>
      <CreateTimeandExpense type={type} />
    </section>
  );
}
